import type { ClientSubIB } from "../../../api/generated";

import { Chip } from "../../../Chip";
import { User02Icon } from "../../../Icons";
import { TooltipWrapper } from "../../../Tooltip";
import { Typo } from "../../../Typo";
import { BodyTypo } from "../../Common/BodyTypo";
import { useRebateProgramCellTranslate } from "./useRebateProgramCellTranslate";

export type RebateProgramCellProps = {
  hasOfferID: string | null;
  subIBs?: ClientSubIB[] | null;
  onSharedProgramClick?: (hasOfferID: string) => void;
};

export const RebateProgramCell = ({
  hasOfferID,
  subIBs,
  onSharedProgramClick,
}: RebateProgramCellProps) => {
  const translations = useRebateProgramCellTranslate();

  if (!hasOfferID) return null;

  const [firstSubIB, ...otherSubIBs] = subIBs ?? [];

  if (!firstSubIB || !onSharedProgramClick) {
    return <BodyTypo text={translations.hoid(hasOfferID)} />;
  }

  return (
    <TooltipWrapper
      text={translations.sharedTooltip}
      color="blue"
      tooltipPlacement="top"
      tooltipMaxWidth={176}
      positionStrategy="fixed"
      triggerClassName="-m-3 flex w-[calc(100%+1.5rem)]"
    >
      <button
        type="button"
        onClick={() => onSharedProgramClick(hasOfferID)}
        data-testid={`client_trading_table_rebate_program_${hasOfferID}_button`}
        className="group flex w-full min-w-0 flex-col items-start p-3 text-start hover:bg-background-table-hover"
      >
        <Typo
          element="p"
          type="bodyMD"
          className="w-full truncate group-hover:underline"
        >
          {translations.hoid(hasOfferID)}
        </Typo>
        <div className="flex w-full min-w-0 items-center gap-1">
          <User02Icon className="size-4 shrink-0" aria-hidden />
          <Typo
            element="span"
            type="bodyXS"
            textColor="text-text-secondary"
            className="min-w-0 flex-1 truncate group-hover:underline"
          >
            {firstSubIB.name}
          </Typo>
          {otherSubIBs.length > 0 && (
            <Chip
              bgClass="bg-surface-tonal-bold"
              textColorClass="text-text-secondary"
            >
              {translations.moreSubIBs(otherSubIBs.length)}
            </Chip>
          )}
        </div>
      </button>
    </TooltipWrapper>
  );
};
